export default __webpack_public_path__ + "static/time-d6aee57410f83284d55a0890cc4d2e6a.svg";